<ion-header class="ion-no-shadow ion-no-border">
    <ion-toolbar>
        <ng-container>
            <ion-title class="full">{{ marketplace.translate(userLang).name }}</ion-title>
            <ion-buttons slot="end">
                <ion-button (click)="backClicked()">
                    <ion-icon slot="icon-only"
                              color="dark"
                              name="close"></ion-icon>
                </ion-button>
            </ion-buttons>
        </ng-container>
    </ion-toolbar>
</ion-header>

<div class="scroll-box"
     [innerHTML]="marketplace.translate(userLang).description">
</div>

<ion-footer>
    <ion-row class="action-buttons ion-no-padding">
        <ion-col class="ion-no-padding">
            <ion-button (click)="backClicked()">
                {{ 'BUTTON_OK' | translate }}
            </ion-button>
        </ion-col>
    </ion-row>
</ion-footer>